

export type UserPresenceStatus = "online" | "away" | "busy";

export interface WorkspaceItem {
  id: string;
  name: string;
  slug: string;
  role: string;
}

interface FloatingHeaderProps {
  selectedWorkspace: WorkspaceItem;
  displayName: string;
  userStatus: UserPresenceStatus;
  onStatusChange: (status: UserPresenceStatus) => void;
  onExitWorkspace: () => void;
  onSignOut: () => void;
}

export default function FloatingHeader({
  selectedWorkspace,
  displayName,
  userStatus,
  onStatusChange,
  onExitWorkspace,
  onSignOut,
}: FloatingHeaderProps) {
  return (
    <header className="glass-panel floating-header">
      <div className="header-brand">
        <h2 className="header-logo">
          Huddlezen
          <span className="logo-dot"></span>
        </h2>
        <span style={{ fontSize: "0.85rem", background: "rgba(0,0,0,0.06)", padding: "0.2rem 0.6rem", borderRadius: "12px", fontWeight: 600, color: "var(--hz-text-muted)" }}>
          {selectedWorkspace.name}
        </span>
      </div>

      <div style={{ display: "flex", gap: "1.25rem", alignItems: "center" }}>
        {/* Profile Pill */}
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", background: "white", padding: "0.4rem 1rem", borderRadius: "20px", border: "1px solid rgba(0,0,0,0.05)" }}>
          <span style={{ fontSize: "0.9rem", color: "var(--hz-text-muted)" }}>
            Welcome, <strong>{displayName}</strong>
          </span>

          <select
            value={userStatus}
            onChange={(e) => onStatusChange(e.target.value as UserPresenceStatus)}
            style={{
              border: "none",
              background: "none",
              outline: "none",
              fontSize: "0.9rem",
              fontWeight: 600,
              cursor: "pointer",
              paddingLeft: "0.25rem",
            }}
          >
            <option value="online">🟢 Online</option>
            <option value="away">🟡 Away</option>
            <option value="busy">🔴 Busy</option>
          </select>
        </div>

        <button
          className="auth-btn"
          onClick={onExitWorkspace}
          style={{
            padding: "0.5rem 1.1rem",
            background: "white",
            border: "1px solid rgba(0,0,0,0.1)",
            borderRadius: "20px",
            fontSize: "0.85rem",
            fontWeight: 600,
            cursor: "pointer",
            width: "auto",
            transition: "all var(--hz-transition-fast)",
          }}
        >
          Exit Lobby
        </button>
        <button
          className="auth-btn"
          onClick={onSignOut}
          style={{
            padding: "0.5rem 1.1rem",
            background: "var(--hz-brand-terracotta-light)",
            border: "1px solid transparent",
            color: "var(--hz-brand-terracotta)",
            borderRadius: "20px",
            fontSize: "0.85rem",
            fontWeight: 600,
            cursor: "pointer",
            width: "auto",
            transition: "all var(--hz-transition-fast)",
          }}
        >
          Sign Out
        </button>
      </div>
    </header>
  );
}
